import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { History, Loader2 } from "lucide-react";
import { adminApi } from "../../lib/api";

export const VehicleHistory = ({ registration, excludeJobId }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!registration) {
      setLoading(false);
      return;
    }
    (async () => {
      try {
        const r = await adminApi.vehicleHistory(registration, excludeJobId);
        setHistory(r);
      } catch (e) {
        setHistory([]);
      } finally {
        setLoading(false);
      }
    })();
  }, [registration, excludeJobId]);

  if (!registration) return null;
  if (loading) {
    return (
      <div className="bg-white border border-[#cfd7db] rounded-md p-4 inline-flex items-center gap-2 text-sm text-[#3f4b52]">
        <Loader2 size={14} className="animate-spin" /> Checking vehicle history…
      </div>
    );
  }
  if (history.length === 0) {
    return (
      <div className="bg-white border border-[#cfd7db] rounded-md p-4 text-sm text-[#3f4b52]" data-testid="vehicle-history-empty">
        <div className="font-display uppercase tracking-widest text-xs text-[#3f4b52] mb-1 inline-flex items-center gap-2">
          <History size={12} /> Vehicle history · {registration}
        </div>
        First time we're working on this registration — clean slate.
      </div>
    );
  }
  return (
    <div className="bg-white border border-[#cfd7db] rounded-md p-5 shadow-sm" data-testid="vehicle-history">
      <div className="font-display uppercase tracking-widest text-xs text-[#f28a16] mb-3 inline-flex items-center gap-2">
        <History size={12} /> Vehicle history · {registration} · {history.length} prior job(s)
      </div>
      <ul className="divide-y divide-[#eef2f4]">
        {history.map((h) => (
          <li key={h.id} className="py-2.5 flex items-start justify-between gap-3 text-sm" data-testid={`history-${h.id}`}>
            <div className="min-w-0">
              <Link to={`/admin/jobs/${h.id}`} className="font-display font-bold text-[#111619] hover:text-[#f28a16]">
                #{h.job_number}
              </Link>{" "}
              <span className="text-[#3f4b52]">· {h.fitment_date || "—"} · {h.client_name}</span>
              <div className="text-xs text-[#3f4b52] mt-0.5">
                {h.vehicle || "—"}
                {h.insurance_company && <> · {h.insurance_company}</>}
                {h.claim_number && <> · Claim {h.claim_number}</>}
                {h.cause_of_loss && <> · {h.cause_of_loss}</>}
              </div>
            </div>
            <div className="text-right shrink-0">
              <div className="text-xs font-display uppercase tracking-widest text-[#3f4b52]">{h.status}</div>
              <div className="text-xs mt-0.5" style={{ color: h.payment_received ? "#10b981" : "#dc2626" }}>
                {h.payment_received ? "Paid" : "Unpaid"}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default VehicleHistory;
